import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { Base_url } from '../../utils/Base_url';

const investorService = createApi({
  reducerPath: 'investor',
  tagTypes: 'investors',
  keepUnusedDataFor: 120,
  baseQuery: fetchBaseQuery({
    baseUrl: `${Base_url}/v1/`
  }),
  endpoints: (builder) => {
    return {
      create: builder.mutation({
        query: (name) => {
          return {
            url: 'worker/create-investor',
            method: 'POST',
            body: name
          };
        }
      }),
      enroll: builder.mutation({
        query: (name) => {
          return {
            url: 'worker/enroll',
            method: 'POST',
            body: name
          };
        }
      }),
      updateinvestor: builder.mutation({
        query: (data) => {
          return {
            url: `update/${data.id}`,
            method: 'PUT',
            body: { name: data.name }
          };
        }
      }),
      deleteinvestor: builder.mutation({
        query: (id) => {
          return {
            url: `delete/${id}`,
            method: 'DELETE'
          };
        }
      }),
      fetchinvestor: builder.mutation({
        query: (name) => {
          return {
            url: `worker/my-investor`,
            method: 'POST',
            body: name
          };
        }
      }),
      fetchmyinvestor: builder.query({
        query: (id) => {
          return {
            url: `worker/my-investor/${id}`,
            method: 'GET'
            // body: name,
          };
        }
      }),
      allinvestors: builder.query({
        query: ({ page = 1, limit = 8, search = '', status = 'active' } = {}) => {
          const params = new URLSearchParams({
            page: String(page),
            limit: String(limit),
            status: status || 'active'
          });
          if (search) params.set('search', search);
          return {
            url: `worker/investor?${params.toString()}`,
            method: 'GET'
          };
        }
      }),
      investorprofile: builder.query({
        query: (id) => {
          return {
            url: `worker/investor-profile/${id}`,
            method: 'GET'
          };
        }
      })
    };
  }
});
export const {
  useCreateMutation,
  useEnrollMutation,
  useFetchinvestorMutation,
  useFetchmyinvestorQuery,
  useAllinvestorsQuery,
  useInvestorprofileQuery,
  useUpdateinvestorMutation,
  useDeleteinvestorMutation
} = investorService;
export default investorService;
